import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getDetails = async (params: object) => {
  return await GET({
    url: Api.details,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
